module.exports = __webpack_public_path__ + "static/media/WiFi_green.dd034acc.png";